module.exports = __webpack_public_path__ + "static/media/12-IMG_6720.da24c97f.JPG";